import { Text } from "@fluentui/react-components";
import type { FC } from "react";
import { useNotificationListHeaderStyles } from "./styles";

const columns = [
  "Time",
  "Alert",
  "Severity",
  "Category",
  "Message",
  "Impact",
  "Actions",
];

const NotificationListHeader: FC = () => {
  const styles = useNotificationListHeaderStyles();

  return (
    <header className={styles.listHeader} role="row" aria-hidden="true">
      {columns.map((column) => (
        <Text key={column} className={styles.headerCell} size={300}>
          {column}
        </Text>
      ))}
    </header>
  );
};

export default NotificationListHeader;
